import React from 'react';
import CollectionLabel from './CollectionLabel';

const CollectionsLabels = ({
  collections,
  showLogo = true,
  asLink = true,
}) => (
  <>
    {collections.map((collection) => (
      <CollectionLabel
        key={collection.code}
        collection={collection}
        showLogo={showLogo}
        asLink={asLink}
      />
    ))}
  </>
);

export default CollectionsLabels;
